module.exports = __webpack_public_path__ + "img/mobilenewsLogo1.bad078c4.png";